// extracted by mini-css-extract-plugin
module.exports = {"content":"e2ff468f85--content--QpXCJ","footer":"e2ff468f85--footer--hy8p_"};